module.exports = {
      id: "icon-card-unknown-usage",
      viewBox: "0 0 44 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-card-unknown",
      toString: function () {
        return this.url;
      }
    }